import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PATTERN } from 'src/app/constants/pattern';
import { ALERT_ERRORS, DAVIPLATA_VALIDATIONS } from 'src/app/core/constants/Errors';
import { DOC_TYPES_DAVIPLATA } from 'src/app/core/constants/FormLists';
import { Payment, Transaction } from 'src/app/models';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { NativeDaviplataService } from './services/native-daviplata.service';
import { DaviPlataRequest } from 'src/app/models/daviPlataRequest.model';
import { AlertService } from 'src/app/services/alert.service';
import { DaviPlataResponse } from 'src/app/models/daviPlataResponse.model';
import { AUTOCOMPLETE_METHOD_PAY_TYPES, DAVIPLATA_NATIVE_OTP_CODE_LENGTH, FLAGS_NAME, GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { ConfirmPurchaseRequest } from 'src/app/models/confirmPurchaseRequest.model';
import { ConfirmPurchaseResponse } from 'src/app/models/confirmPurchaseResponse.model';
import { Router } from '@angular/router';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { PatchValAdditionalInfoService } from 'src/app/services/patch-val-additional-info.service';

@Component({
  selector: 'app-native-daviplata',
  templateUrl: './native-daviplata.component.html',
  styleUrls: ['./native-daviplata.component.scss']
})
export class NativeDaviplataComponent implements OnInit {
  @Input() information: Payment;
  @Input() transaction: Transaction;
  @Output() DAVIPLATA = new EventEmitter();

  form: FormGroup;
  generalConstants = GENERAL_CONSTANTS;
  listOfDocuments = DOC_TYPES_DAVIPLATA;
  errorsMessages = DAVIPLATA_VALIDATIONS;
  daviplataConstants = GENERAL_CONSTANTS.DAVIPLATA_RESPONSE;
  responseMsg = GENERAL_CONSTANTS.DAVIPLATA_RESPONSE.RESPONSE_MESSAGES;
  template: string;
  checkoutToken = '';
  buttonMessage = 'Continuar';
  orderState = 'inProgress'
  transactionId = '';
  counterTime: string;
  initTime: number;
  orderAmountTemp = 0;
  loading = false;
  formPrivacyValid = false;
  formStepOne = true;
  interval: any;
  otpMinMaxLength: number = DAVIPLATA_NATIVE_OTP_CODE_LENGTH.MIN_MAX;
  daviplataUserFieldsOnOtpViewFf: boolean = false;
  isEditableInfo: boolean = false;
  walletsAutoCompleteFF: boolean = false;
  objectControlData = [
    {
      formControl: 'documentType',
      readOnly: false,
    },
    {
      formControl: 'documentNumber',
      readOnly: false,
    },
  ];
  showNewOtpMsg = false;

  constructor(
    private tokenService: TokenServiceService,
    private formBuilder: FormBuilder,
    private daviplataService: NativeDaviplataService,
    private alertService: AlertService,
    private router: Router,
    private featureFlagService: PayvalidaFeatureFlagService,
    private readonly patchValAdditionalInfoService: PatchValAdditionalInfoService,
  ) {
    this.form = this.formBuilder.group({
      documentNumber: ['', Validators.compose([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(16),
        Validators.pattern(PATTERN.NUMBERS)
      ])],
      documentType: ['', Validators.required],
      codeOtp: ['']
    });
  }

  ngOnInit(): void {
    this.setupValuesToTimer();

    this.template = this.information.template;
    this.orderAmountTemp = Number(this.transaction.ORDER_AMOUT);
    this.checkoutToken = this.tokenService.getToken();

    this.patchValueForms();

    this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.WALLETS_AUTOCOMPLETE_FF, FLAGS_NAME.WALLETS_AUTOCOMPLETE_FF)
    .subscribe((response: boolean) => {
      this.walletsAutoCompleteFF = response
      const additionalInfo = this.tokenService.exitsAdditionalInformation(this.transaction);

      if (additionalInfo) return  this.disabledItems(additionalInfo);
    });

    this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.DAVIPLATA_USER_FIELDS_ON_OTP_VIEW, FLAGS_NAME.DAVIPLATA_USER_FIELDS_ON_OTP_VIEW, GENERAL_CONSTANTS.PAYVALIDA_FF_PLATFORM)
      .subscribe((response: boolean) => this.daviplataUserFieldsOnOtpViewFf = response);

    this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.CHANGE_DAVIPLATA_OTP_MSG, FLAGS_NAME.CHANGE_DAVIPLATA_OTP_MSG, GENERAL_CONSTANTS.PAYVALIDA_FF_PLATFORM)
      .subscribe((showNewOtpMsgResponse: boolean) => this.showNewOtpMsg = showNewOtpMsgResponse);
  }

  /**
     *
     * @description {isControlReadOnly} function to check if form fields are read-only
     * @param controlName
     * @returns
     */
  isControlReadOnly(controlName: string): boolean {
    const readOnlyControl = this.objectControlData.find((m) => m.formControl === controlName);

    return readOnlyControl ? readOnlyControl.readOnly : false;
  }

   /**
   *
   * @description {disabledItems} Function to disabled items to checkout form
   */
  disabledItems(additionalInfo) {
    try {
      this.isEditableInfo = this.tokenService.isEditableInfo(additionalInfo);

      return  this.patchValAdditionalInfoService.patchValAdditionalInfo(
        this.isEditableInfo,
        additionalInfo,
        this.form,
        AUTOCOMPLETE_METHOD_PAY_TYPES.DAVIPLATA_NATIVE,
        this.objectControlData,
      );
    } catch (_) {
        this.alertService.showAlert(ALERT_ERRORS.GET_TOKEN_DATA_ERROR);
    }
  }

  /**
   *
   * @description {patchValueForms} Function to assign default values to the form
  */
  patchValueForms = () => {
    this.form.get('codeOtp').clearValidators();
    this.form.get('documentNumber').patchValue(this.transaction.USER_DI);

    const find = this.findDocumentType(this.transaction.USER_TYPE_DI);

    if (find) this.form.get('documentType').patchValue(find.value);
  }

  /**
  *
  * @description {patchValueForms} Function to assign default values to the form
  */
  findDocumentType = (documentType: string) => this.listOfDocuments.find((tipoDocumento) => tipoDocumento.value === documentType);


  /**
   * @description Function that returns to payment methods
  */
  changeMethod = () => this.DAVIPLATA.emit();

  /**
   *
   * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
   * @param valid
  */
  formPrivacyUpdate = (valid: boolean) => this.formPrivacyValid = valid;

  /**
   *
   * @description {completedForms} Function to validate the validations of the parent component and child component
   * @returns
  */
  completedForms = (): boolean => this.form.valid && this.formPrivacyValid;

  /**
   * @description {daviplataPurchaseIntentionControl} Function to call daviplata services according to the form
  */
  daviplataPurchaseIntentionControl = () => {
    if (this.formStepOne) return this.daviplataPurchaseIntention();;

    this.confirmPurchase();
  }

  /**
   *
   * @description {generatePayment} Function to generate daviplata Purchase Intention
  */
  daviplataPurchaseIntention = () => {
    this.loading = true;

    let requestBody: DaviPlataRequest = {
      token: this.checkoutToken,
      document_type: this.form.get('documentType').value,
      document_number: this.form.get('documentNumber').value,
      accepts_terms: this.formPrivacyValid
    };

    this.daviplataService.daviplataPurchaseIntention(requestBody).subscribe({
      next: (response: DaviPlataResponse) => this.buildDaviPlataResponse(response.CODE, response.DATA),
      error: () => {
        this.loading = false;
        this.alertService.showAlertProblem();
      },
    });
  }

  /**
   *
   * @description {buildDaviPlataResponse} Function to build daviplata purchase intention response
   * @param responseCode
  */
  buildDaviPlataResponse = (responseCode: string, transactionId?: string) => {
    switch (responseCode) {
      case this.generalConstants.OK_RESPONSE_CODE:
        this.activatedOtpStep(transactionId);
        break;
      case this.generalConstants.UNAUTHORIZED_CODE:
      case this.daviplataConstants.INVALID_TOKEN:
      case this.daviplataConstants.INVALID_ORDER:
      case this.daviplataConstants.INTERNAL_ERROR:
        this.alertService.showAlert(this.responseMsg.ERROR_LIMIT_TRANSACTIONS);
        break;
      case this.daviplataConstants.INVALID_ACCOUNT:
        this.alertService.showAlert(this.responseMsg.INVALID_ACCOUNT, 'warning');
        break;
      case this.daviplataConstants.INSUFICCIENT_BALANCE:
        this.alertService.showAlert(this.responseMsg.INSUFICCIENT_BALANCE, 'warning');
        break;
      case this.daviplataConstants.TRANSACTION_NOT_FOUND:
        this.alertService.showAlert(this.responseMsg.TRANSACTION_NOT_FOUND, 'warning');
        break;
      case this.daviplataConstants.INVALID_OTP_CODE:
        this.alertService.showAlert(this.responseMsg.INVALID_OTP, 'warning');
        break;
      default:
        this.alertService.showAlertProblem();
        break;
    };

    this.loading = false;
  }

  /**
   *
   * @description {activatedOtpStep} Function to activate the OTP form
  */
  activatedOtpStep = (transactionId: string) => {
    this.initCounter();

    this.formStepOne = false;
    this.buttonMessage = 'Confirmar';

    this.form.get('documentNumber').clearValidators();
    this.form.get('documentType').clearValidators();

    this.form.get('codeOtp').setValidators(Validators.compose([
      Validators.required,
      Validators.minLength(this.otpMinMaxLength),
      Validators.maxLength(this.otpMinMaxLength),
      Validators.pattern(PATTERN.NUMBERS),
    ]));

    this.transactionId = transactionId;
  }

  /**
   * @description {initCounter} Function to start the counter of the OTP form
  */
  initCounter = () => {
    this.updateCounter();

    this.interval = setInterval(() => this.updateCounter(), 1000);
  }

  /**
   * @description {formatTime} Function to format the counter time of the OTP form
   * @param seconds
   * @returns
  */
  formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secondsRemaining = seconds % 60;

    const minutesFormat = minutes < 10 ? '0' + minutes : minutes.toString();
    const secondsFormat = secondsRemaining < 10 ? '0' + secondsRemaining : secondsRemaining.toString();

    return minutesFormat + ':' + secondsFormat;
  }

  /**
   * @description {updateCounter} Function to update the OTP timer counter and clear the counter interval
   * @param seconds
   * @returns
  */
  updateCounter = () => {
    this.counterTime = this.formatTime(this.initTime);

    if (this.initTime <= 0) {
      clearInterval(this.interval);

      return this.setupValidatorsStepOne();
    }

    this.initTime--;
  }

  /**
   * @description {setupValidatorsStepOne} Function to setup validators step one
  */
  setupValidatorsStepOne = () => {
    this.buttonMessage = 'Continuar';

    this.form.get('codeOtp').setValue('');
    this.form.get('codeOtp').clearValidators();
    this.form.get('documentType').setValidators(Validators.required);
    this.form.get('documentNumber').setValidators(Validators.compose([
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(16),
      Validators.pattern(PATTERN.NUMBERS)
    ]));
    this.form.get('documentNumber').updateValueAndValidity();
    this.form.get('documentType').updateValueAndValidity();
    this.form.get('codeOtp').updateValueAndValidity();

    this.setupValuesToTimer();

    this.formPrivacyValid = false;
    this.formStepOne = true;
  }

  /**
   * @description {setupValuesToTimer} Function to setup values to timer container
  */
  setupValuesToTimer = () => {
    clearInterval(this.interval);

    this.counterTime = '03:00';
    this.initTime = 180;
  }

  /**
   *
   * @description {confirmPurchase} Function to call confirm purchase
  */
  confirmPurchase = () => {
    this.loading = true;

    let requestBody: ConfirmPurchaseRequest = {
      token: this.checkoutToken,
      transactionId: this.transactionId,
      otp: this.form.get('codeOtp').value
    };

    this.daviplataService.confirmPurchase(requestBody).subscribe({
      next: (response: ConfirmPurchaseResponse) => {
        if (this.isOrderApproved(response.CODE)) {
          this.orderState = response.CODE === this.generalConstants.OK_RESPONSE_CODE &&
            this.orderState !== 'approved'
            ? 'approved'
            : this.orderState;

          let infoOrderStatus = {
            orderCode: response.DATA.orderCode,
            reference: response.DATA.reference,
            approvalNumber: response.DATA.approvalNumber,
            state: this.orderState,
            token: this.checkoutToken
          }

          localStorage.setItem('infoOrderStatus', JSON.stringify(infoOrderStatus));

          this.router.navigate(['checkout/voucher'], { queryParams: { token: this.checkoutToken } });
          this.loading = false;

          return;
        };

        this.buildDaviPlataResponse(response.CODE);
        this.setupValidatorsStepOne();
      },
      error: () => this.alertService.showAlertProblem()
    })
  }

  /**
   *
   * @description {isOrderApproved} Function to validate if the order was approved
   * @param code response code
   * @returns boolean
  */
  isOrderApproved = (code: string) => code === this.generalConstants.OK_RESPONSE_CODE || code === this.daviplataConstants.ERROR_CONFIRM_TRANSACTION;
}
